(function($) {

	'use strict';

	var init = function() {

        $(window).resize(function(){

            videoRatio();

        }).resize();

    };
  
    var videoRatio = function() {
        
        $('.videoContainer iframe').each(function(){

            var height = ($(this).width() / 16) * 9;

            $(this).height(height);

        });

    }
  
	$(document).ready(function() {
		init(); 
	});

})(jQuery);
